import { render, staticRenderFns } from "./TimeoffSidebar.vue?vue&type=template&id=61206c62&lang=html&"
import script from "./TimeoffSidebar.vue?vue&type=script&lang=js&"
export * from "./TimeoffSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports